import { Table, TableHead, TableRow, TableCell, TableBody, Box, Button } from "@mui/material";
import ManualEntry from "./ManualEntry";
import ModalView from "../model/ModelView";
import { useEffect, useRef, useState } from "react";
import { useTheme, useMediaQuery } from "@mui/material";
import authService from "../Auth/AuthService";

export default function AttendanceTable({ records = [], onSuccess }) {

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md"));

  const hasFetched = useRef(false);
  const [openEntry, setOpenEntry] = useState(false);
  const [selected, setSelected] = useState({});
  const tokenInfo = authService.tokenInfo();

  useEffect(() => {
    if (hasFetched.current) return;
    hasFetched.current = true;
    // loadData();
  }, []);

  const handleClose = () => {
    setOpenEntry(false);
  };

  const handleForm = (data) => {
    setOpenEntry(true);
    setSelected(data);
  };

  const handleApprove = async (record) => {
    await authService.putAuth(
      authService.pathUrl("PUT", "/attendance/approve"), record
    )
    if (onSuccess) onSuccess();
  }

  const columns = {
    date: true,
    distance: !isMobile,
    shift: !isMobile,
    leave: !isMobile && !isTablet,
    in: true,
    out: true,
    hours: !isMobile,
    action: true,
    inDistance: !isMobile,
    outDistance: !isMobile,
  };


  if (!records.length) return null;

  return (
    <Box sx={{ width: "100%", overflowX: "auto" }}>
      <Table size={isMobile ? "small" : "medium"}>
        <TableHead>
          <TableRow>
            {columns.date && <TableCell>Date</TableCell>}
            {columns.inDistance && <TableCell>Intime Distance</TableCell>}
            {columns.outDistance && <TableCell>Outtime Distance</TableCell>}
            {columns.distance && <TableCell>Distance</TableCell>}
            {columns.shift && <TableCell>Shift</TableCell>}
            {columns.leave && <TableCell>Leave</TableCell>}
            {columns.in && <TableCell>In</TableCell>}
            {columns.out && <TableCell>Out</TableCell>}
            {columns.hours && <TableCell>Hours</TableCell>}
            {columns.action && <TableCell>Action</TableCell>}
          </TableRow>
        </TableHead>

        <TableBody>
          {records.map(record => (
            <TableRow key={record?.id ?? record?.attendDate ?? Math.random()}>
              {columns.date && <TableCell>{record.attendDate}</TableCell>}
              {columns.inDistance && <TableCell>{record.inDistance || "-"}</TableCell>}
              {columns.outDistance && <TableCell>{record.outDistance || "-"}</TableCell>}
              {columns.distance && <TableCell>{record.distance || "-"}</TableCell>}
              {columns.shift && <TableCell>{record.shift || "-"}</TableCell>}
              {columns.leave && <TableCell>{record.leaveState || "-"}</TableCell>}
              {columns.in && <TableCell>{record.inTime || "-"}</TableCell>}
              {columns.out && <TableCell>{record.outTime || "-"}</TableCell>}
              {columns.hours && (
                <TableCell>
                  {record?.totalHours
                    ? record.totalHours.substring(2, 4) + " hrs"
                    : "-"}
                </TableCell>
              )}
              {columns.action && (
                <TableCell>
                  {record?.inTime && !record?.outTime && (
                    <Button size="small" onClick={() => handleForm(record)}>
                      Out Time
                    </Button>
                  )}
                  {!record?.inTime && !record?.outTime && (
                    <Button size="small" onClick={() => handleForm(record)}>
                      Add Time
                    </Button>
                  )}
                  {tokenInfo?.roles === 'ADMIN' && record?.status == 'PENDING' ? (
                    <Button size="small" onClick={() => handleApprove(record)}>
                      APPROVE
                    </Button>) : (
                    record?.inTime && record?.outTime && "Done"
                  )}
                  {/* {record?.inTime && record?.outTime && "Done"} */}
                </TableCell>
              )}
            </TableRow>
          ))}
        </TableBody>
      </Table>

      <ModalView size={'sm'}
        open={openEntry}
        handleClose={handleClose}
        title="Add Time "
        content={<ManualEntry record={selected} onSuccess={() => {
          setOpenEntry(false);
          if (onSuccess) onSuccess();
        }} />}
      />
    </Box>
  );
}

